
import { useEffect, useState } from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import Error from './components/Error';
import RecallContainer from './components/RecallContainer';
function App() {
  const [chassis, setChassis] = useState("");

  return (
    <div className='app'>
     
     <Router>
    <Routes>
      <Route exact path="/" element={<RecallContainer/>} />
      <Route path='/error' element={<Error/>} />
    </Routes>
    </Router>
    </div>
  );
}

export default App;
